import React from 'react';
import { PageTitle } from './PageTitle';
import { IconDownload } from '@tabler/icons';

export const TermsOfService = () => (
  <div
    style={{
      background: 'linear-gradient(#74C9E6, #3174AB)', // no-repeat bottom url("./assets/images/login-bg.svg"),
      backgroundSize: 'cover',
      minHeight: '100%',
      paddingBottom: '1em',
    }}
  >
    <div
      style={{
        background: '#ffffff',
        padding: '1em',
      }}
    >
      <a href="login">
        <img
          src="assets/images/aquifer-logo-rgb.svg"
          style={{
            margin: '0 auto',
            display: 'block',
            width: '255px',
          }}
        />
      </a>
    </div>
    <section
      style={{
        margin: '1em auto',
        maxWidth: 800,
        background: '#ffffff',
        padding: '1em',
      }}
    >
      <PageTitle>Terms of Service</PageTitle>
      <a
        href="assets/Aquifer, Inc Common Paper TOS - 05172025 - Word.pdf"
        download
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 6,
          marginBottom: 16,
          textDecoration: 'none',
          color: '#3174AB',
          fontWeight: 500,
        }}
      >
        <IconDownload style={{ height: 20, verticalAlign: 'middle' }} />
        Download PDF
      </a>

      <h1>Aquifer, Inc Terms of Service</h1>
      <p>
        <strong>Last Updated: May 17, 2025</strong>
      </p>
      <p>
        If you signed a separate Cover Page to access the Product with the same
        account, and that agreement has not ended, the terms below do not apply
        to you. Instead, your separate Cover Page applies to your use of the
        Product.
      </p>
      <p>
        This Agreement is between Aquifer, Inc and the company or person
        accessing or using the Product. This Agreement consists of: (1) the
        Order Form below and (2) the Framework Terms defined below.
      </p>
      <p>
        If you are accessing or using the Product on behalf of your company, you
        represent that you are authorized to accept this Agreement on behalf of
        your company. By signing up, accessing, or using the Product, Customer
        indicates its acceptance of this Agreement and agrees to be bound by the
        terms and conditions of this Agreement.
      </p>
      <h2>Cover Page</h2>
      <p>
        <em>Order Form</em>
      </p>
      <p>
        <strong>Framework Terms: </strong>
        This Order Form incorporates and is governed by the Framework Terms that
        are made up of the Key Terms below and the Common Paper{' '}
        <a href="https://commonpaper.com/standards/cloud-service-agreement/2.1/">
          Cloud Service Agreement Standard Terms Version 2.1
        </a>
        , which are incorporated by reference. Any modifications to the Standard
        Terms made in the Cover Page will control over conflicts with the
        Standard Terms. Capitalized words have the meanings given in the Cover
        Page or the Standard Terms.
      </p>
      <p>
        <strong>Cloud Service: </strong>
        Aquifer is an integration platform that allows you to extract data from
        the tools you use everyday, and push that data to destinations (either
        an SQL database or other connector sources). The Cloud Service is
        defined as usage of the Aquifer Platform and associated support relating
        to integrations served by the platform.
      </p>
      <p>
        <strong>Order Date: </strong>
        The Effective Date
      </p>
      <p>
        <strong>Subscription Period:</strong> 1 year(s)
      </p>
      <p>
        <strong>Cloud Service Fees:</strong>
        Customer pays per pre-built integration or for individual connections
        and implementation and maintenance fees.
      </p>
      <p>
        <strong>Payment Process:</strong>
        Automatic payment: Customer authorizes Provider to bill and charge
        Customer's payment method on file Annually for immediate payment or
        deduction without further approval.
      </p>
      <p>
        <strong>Non-Renewal Notice Period:</strong> At least 30 days before the
        end of the current Subscription Period.
      </p>
      <p>
        <em>Key Terms</em>
      </p>
      <p>
        <strong>Customer:</strong> The company or person who accesses or uses
        the Product. If the person accepting this Agreement is doing so on
        behalf of a company, all use of the word "Customer" in the Agreement
        will mean that company.
      </p>
      <p>
        <strong>Provider:</strong> Aquifer, Inc
      </p>
      <p>
        <strong>Effective Date:</strong> The date Customer first accepts this
        Agreement.
      </p>
      <p>
        <strong>Governing Law:</strong> The laws of the State of Delaware
      </p>
      <p>
        <strong>Chosen Courts:</strong> The state or federal courts located in
        Delaware
      </p>
      <p>
        <strong>Covered Claims:</strong>
      </p>
      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>Provider Covered Claims:</strong>{' '}
        Any action, proceeding, or claim that the Cloud Service, when used by
        Customer according to the terms of the Agreement, violates,
        misappropriates, or otherwise infringes upon anyone else's intellectual
        property or other proprietary rights.
      </p>
      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>Customer Covered Claims:</strong>{' '}
        Any action, proceeding, or claim that (1) the Customer Content, when
        used according to the terms of the Agreement, violates, misappropriates,
        or otherwise infringes upon anyone else's intellectual property or other
        proprietary rights; or (2) results from Customer's breach or alleged
        breach of Section 2.1 (Restrictions on Customer).
      </p>
      <p>
        <strong>General Cap Amount:</strong>
        The fees paid or payable by Customer to provider in the 12 month period
        immediately before the claim
      </p>
      <p>
        <strong>Notice Address:</strong>
      </p>
      <p>For Provider: notices@aquifer.cloud</p>
      <p>For Customer: The main email address on Customer's account</p>
    </section>
  </div>
);
